export function notProperlyDefined(valueName) {
    return `"${valueName}" not properly defined`;
}
